import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '@services/hiring-manger-profiledata.service';
import { GlobalErrorService } from '@services/global-error.service';
import { vendorInfo } from '@interfaces/vendor-profile.model';
import { vendorProfileInfo } from '@shared/constants/global.enum'
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-vendor-info',
  templateUrl: './vendor-info.component.html',
  styleUrls: ['./vendor-info.component.scss'],
})
export class VendorInfoComponent implements OnInit {
  // vendorId is required by downstream service calls; use empty string default instead of null to satisfy typing
  @Input() vendorId: string = '';


  about: Partial<vendorInfo> = {};
  vendorContact: Partial<vendorInfo>[] = [];

  selectedYear: number = new Date().getFullYear();
  selectedMonth: string = (new Date().getMonth() + 1).toString();

  aboutDetails: { label: string; key: keyof vendorInfo }[] = [
    { label: vendorProfileInfo.labelVendorPSID, key: vendorProfileInfo.keyVendorId as keyof vendorInfo },
    { label: vendorProfileInfo.labelFullAddress, key: vendorProfileInfo.keyFullAddress as keyof vendorInfo },
    { label: vendorProfileInfo.labelEmailID, key: vendorProfileInfo.keyEmailVendor as keyof vendorInfo },
    { label: vendorProfileInfo.labelDateOfOnboarding, key: vendorProfileInfo.keyDateOfOnboarding as keyof vendorInfo },
    { label: vendorProfileInfo.labelMSAExpiryDate, key: vendorProfileInfo.keyMsaexpiryDate as keyof vendorInfo },
    { label: vendorProfileInfo.labelC2H, key: vendorProfileInfo.keyC2H as keyof vendorInfo },
    { label: vendorProfileInfo.labelReleaseTimeline, key: vendorProfileInfo.keyReleaseTimeline as keyof vendorInfo },
  ];

  contactDetails: { label: string; key: keyof vendorInfo }[] = [
    { label: vendorProfileInfo.labelPointOfContact, key: vendorProfileInfo.keyPointOfContact as keyof vendorInfo },
    { label: vendorProfileInfo.labelDesignation, key: vendorProfileInfo.keyDesignation as keyof vendorInfo },
    { label: vendorProfileInfo.labelEmail, key: vendorProfileInfo.keyEmail as keyof vendorInfo },
    { label: vendorProfileInfo.labelMobileNumber, key: vendorProfileInfo.keyMobileNumber as keyof vendorInfo },
    { label: vendorProfileInfo.labelLocation, key: vendorProfileInfo.keyLocation as keyof vendorInfo },
  ];

  constructor(private dataService: DataService, private errorHandler: GlobalErrorService, private route: ActivatedRoute) {}

  private showError(message: string): void {
    alert(message);
  }
  ngOnInit(): void {
      this.loadVendorInfo();
  }

  loadVendorInfo(): void {

    this.dataService.getVendorData(this.vendorId)
      .subscribe({
        next: (response) => {
          const vendorData = response.data;
          const first = vendorData[0];

          if (first) {
            this.about = {
                vendorId: first.vendorId || '',
                fullAddress: first.fullAddress || '',
                emailVendor: first.emailVendor || '',
                dateOfOnboarding: first.dateOfOnboarding || '',
                msaexpiryDate: first.msaexpiryDate || '',
                c2h: first.c2h || '',
                releaseTimeline: first.releaseTimeline || '',
            };

            this.vendorContact = vendorData.slice(1).map((record: any) => ({
              pointOfContact: record.pointOfContact || '',
              designation: record.designation || '',
              email: record.email || '',
              contact: record.contact || '',
              location: record.location || '',
            }));
            } else {
              this.showError('Vendor information is unavailable.');
          }
        },
        error: (error) => {
          this.errorHandler.logComponentError(error);
        },
      });
  }
}
